import { ACTIONS } from '../engine';
import type { Action, GameState } from '../engine';

export const newGame = ({ mode, seed, starterPlayerId }: { mode: GameState['mode']; seed?: string; starterPlayerId?: string }): Action => ({
  type: ACTIONS.NEW_GAME,
  mode,
  seed,
  starterPlayerId,
});

export const dealInitial = (): Action => ({ type: ACTIONS.DEAL_INITIAL });

export const startRound = (roundIndex?: number): Action => ({
  type: ACTIONS.START_ROUND,
  roundIndex,
});

export const placePendingRoyals = (playerId: string): Action => ({
  type: ACTIONS.PLACE_PENDING_ROYALS,
  playerId,
});

export const drop = (playerId: string, cardId: string): Action => ({
  type: ACTIONS.DROP,
  playerId,
  cardId,
});

export const absorbChoose = (playerId: string, choiceId: string): Action => ({
  type: ACTIONS.ABSORB_CHOOSE,
  playerId,
  choiceId,
});

export const absorbSkip = (playerId: string): Action => ({
  type: ACTIONS.ABSORB_SKIP,
  playerId,
});
